/**
 * Определяем на каком этапе заполнения ФИО находится пользователь
 * isAfterSurnameSpaceSymbol - заполнил фамилию и нажал пробел
 * isAfterNameSpaceSymbol - заполнил имя и нажал пробел
 * isFIOFinished - полностью заполнил ФИО
 * isFIFinished - заполнил как минимум ФИ (и более)
 */
export function getFillProgress(inputSplitValue: string[]) {
  return {
    isAfterSurnameSpaceSymbol: inputSplitValue.length === 2 && !inputSplitValue[1],
    isAfterNameSpaceSymbol: inputSplitValue.length === 3 && !inputSplitValue[2],
    isFIOFinished: Boolean(inputSplitValue.length >= 4 && inputSplitValue[2]),
    isFIFinished: Boolean(inputSplitValue.length >= 2 && inputSplitValue[1]),
  };
}
